<template>
  <div :class="[b(), className]" :style="styleSizeName">
    <div :ref="id" :style="styleChartName"></div>
  </div>
</template>

<script>
// import create from "../../create";
import companyIcon from "@/assets/img/newCompany.png"; // 公司图标
import factoryIcon from "@/assets/img/newFactory.png"; // 工厂图标
import provinceBgIcon from "@/assets/img/provinceBg.png"; // 省市区显示名称的背景图
import areaBgIcon from "@/assets/img/areaBg.png"; // 区域显示名称的背景图
import mapBg from "./map_bg_bak.png"; // 地图渲染背景图

// 以下参考引入文件areaData.js中的注释
import {
  AREA_LIST,
  AREA_CODE_NAME_MAP,
  AREA_DISTANCE_MAP,
  AREA_NAME_LIST,
  AREA_CODE_MAP,
  AREA_NAME_MAP,
  AREA_JSON_MAP,
  HAI_NAN_JSON,
  PROVINCE_LIST,
  AREA_CP_MAP
} from '@/utils/areaData.js'


// 写死的双碳业务场景下的单位对应指标名称map
const fieldsUnitMap = {
  工厂数量: "家",
  水泥产量: "万吨/年",
  熟料产量: "万吨/年",
  碳排放强度: "tCO2/t",
};

// 格式化指标方法
import {formatValue} from "@/option/common/common.js";
import {getMapData} from '@/api/map';

export default {
  name: "map3D",
  data() {
    return {
      bannerCount: 0,
      bannerCheck: "",
      centerData: [], // 中心点
      zoomData: 1,
      mapDataJson: '', // 地图json数据
      paramKey: '',
      curAreaData: '', // 当前区域数据，用于渲染全国地图跳转到区域地图之后的业务，双碳业务
      filterDistrict: '', // 根据过滤条件获取区域，用于地图的被联动，双碳业务
    };
  },
  watch: {
    mapData() {
      this.updateChart();
    },
    dataChartLen(val) {
      this.setBanner();
    },
    bannerTime() {
      this.setBanner();
    },
    banner: {
      handler() {
        this.setBanner();
      },
      immediate: true,
    },
    width() {
      this.updateData();
    },
    height() {
      this.updateData();
    },
    zoom: {
      handler() {
        this.zoomData = this.zoom;
      },
      immediate: true,
    },
  },
  computed: {
    zoomShow() {
      return this.option.zoomShow || 1;
    },
    zoom() {
      return this.option.zoom || 1;
    },
    mapData() {
      return this.option.mapData || {};
    },
    borderWidth() {
      return this.option.borderWidth || 3;
    },
    borderColor() {
      return this.option.borderColor || "#389BB7";
    },
    areaColor() {
      return this.option.areaColor || "#0c162f";
    },
    empColor() {
      return this.option.empColor || "#fff";
    },
    empAreaColor() {
      return this.option.empAreaColor || "yellow";
    },
    color() {
      return this.option.color || "#fff";
    },
    roam() {
      return this.validData(this.option.roam, true);
    },
    fontSize() {
      return this.option.fontSize || 24;
    },
    bannerTime() {
      return this.option.bannerTime || 3000;
    },
    banner() {
      return this.option.banner;
    },
    locationData() {
      return (this.dataChart || []).map((ele) => {
        ele.zoom = ele.zoom || 1;
        const zoomData = this.zoomData < 1 ? 1 : this.zoomData;
        return Object.assign(
            (() => {
              if (ele.zoom <= zoomData) {
                return {
                  name: ele.name,
                };
              }
              return {};
            })(),
            {
              value: [ele.lng, ele.lat, ele.value],
            }
        );
      });
    },
  },
  methods: {
    // 框架里拷过来的方法，业务上并没有用上
    setBanner() {
      clearInterval(this.bannerCheck);
      if (this.banner) {
        this.bannerCheck = setInterval(() => {
          const curr = this.bannerCount % this.dataChartLen;
          this.bannerCount += 1;
        }, this.bannerTime);
      }
    },
    // 地图工厂之间飞线配置项代码，具体参考echart 3d飞线配置
    initFactoryData(markData) {
      const lineData = []
      markData.forEach((item, index) => {
        lineData.push([[item.value[0], item.value[1]], this.curAreaData.cp])
      })
      // 飞线
      const lineSeries = {
        type: 'lines3D',
        coordinateSystem: 'geo3D',
        effect: {
          show: true,
          trailWidth: 3,
          trailOpacity: 0.5,
          trailLength: 0.2,
          constantSpeed: 5
        },
        blendMode: 'lighter',
        lineStyle: { // 航线的视图效果
          color: '#FFB800',
          width: 1,
          opacity: 0.6
        },
        data: lineData
      }
      return lineSeries
    },
    // 地图json数据请求
    async getMapData() {
      if (!this.mapDataJson && this.mapData) {
        const res = await getMapData(this.mapData)
        this.mapDataJson = res.data
      }
    },
    // 获取单位
    getUnit(name) {
      const fieldItem = this.prop.metrics.find(item => item.fieldName === name) || {}
      return fieldItem?.set?.indexUnit || ''
    },
    // 格式化
    getFormatVal(name) {
      const fieldItem = this.prop.metrics.find(item => item.fieldName === name) || {}
      return formatValue(fieldItem.set, fieldItem, 'value')
    },
    // 获取当前地图的过滤条件，根据过滤条件的区域渲染地图，双碳业务
    initFilterData() {
      const {
        filterDatas = {}
      } = this.prop
      if (filterDatas.conditions && filterDatas.conditions.length) {
        const condition = filterDatas.conditions.find(item => item.code && item.code === 'district') || {}
        this.filterType = condition.code
      }
      if (this.linkData && this.filterType) {
        const [id, field] = filterDatas.conditions[0].bindKey.split('.')
        if (this.linkData[id] && this.linkData[id][field] && this.linkData[id][field].value) {
          this.filterDistrict = this.linkData[id][field].value
        }
      }
    },
    // 判断是否双碳业务模型，由于业务模型的id会变，用名称判断
    isIndividual() {
      let individual = false
      if (this.prop.dataCenter) {
        this.prop.dataCenter?.appList?.forEach(item => {
          if (item.code === this.prop.dataCenter?.modelType && item.name?.indexOf('双碳') >= 0) {
            individual = true
          }
        })
      }
      return true
      return individual
    },
    // 全局一致的更新图表方法
    async updateChart() {
      // if (!this.isDataCenter){
      //   return
      // }
      this.initFilterData()
      let option
      // 双碳走特殊数据处理,
      if (this.isIndividual()) {
        option = await this.generateIndividualOptionData()
      } else {
        // 非双碳走普通数据处理
        option = await this.generateNormalOptionData()
      }
      if (!option) return;
      this.myChart.off("mouseover");
      this.myChart.off("mouseout");
      this.myChart.off("georoam");
      // 报错注释掉
      // this.myChart.on("mouseover", (e) => {
      //     console.log('e>>>>>>', e)
      // });
      // this.myChart.on("mouseout", () => {
      //   this.bannerCount = 0;
      //   this.setBanner();
      // });
      // 地图缩放监听
      this.myChart.on("georoam", (e) => {
        const option = this.myChart.getOption();
        const geo = option.geo[0];
        this.centerData = geo.center;
        this.zoomData = geo.zoom;
        if (this.zoomData < 1) this.zoomData = 1;
      });

      this.myChart.resize();
      // 3d地图需要异步渲染option，否则可能会发生渲染bug，临时解决方案，dataease中也有此问题，框架并未解决
      setTimeout(() => {
        this.myChart.setOption(this.echartsOptionHandler(option), true);
      }, 300)
    },
    // 生成地图通用配置项, 地图配置项核心代码，可参考
    async generateNormalOptionData() {
      // 是否展示默认配置，矿山演示使用的死代码配置项
      const {showDefaultCompany} = this.option
      // 获取维度，指标数据，注：经度纬度用指标处理
      const {
        categories = [],
        series = []
      } = this.getDimentionOption()
      // 获取地图渲染的json数据
      if (!this.mapDataJson) {
        await this.getMapData()
      }
      // 接口返回的是字符串，转一下
      const jsonData = JSON.parse(this.mapDataJson)
      // 处理海南省的geoJson数据，因为海南省的数据默认包含三沙市和南海诸岛及九段线，会占据较大的渲染空间
      const haiNanFeature = jsonData.features.find(feat => feat.properties.name === '海南省')
      haiNanFeature.geometry = HAI_NAN_JSON.geometry
      jsonData.features = [...jsonData.features.filter(feat => feat.properties.name && feat.properties.name !== '海南省'), haiNanFeature]
      // 处理海南省数据完毕
      // 下面要做数据处理，直接深拷贝，避免引用
      const optionData = this.deepClone(jsonData);
      // 注册到window，这个不是一定要做的，但是avue框架默认是这么处理，抄过来了
      window.echarts.registerMap("china", optionData);
      // 因为经纬度不是单独的数据项，是和指标放在一起的，所以要做数据处理
      let seriesObj = {}
      series.forEach(item => {
        seriesObj[item.name] = item.data
      })
      // 生成option中传入的data渲染数据，主要处理指标数据等的渲染
      const renderData = categories.map((item, index) => {
        let obj = {}
        /* 地图标点，塞入option的渲染数据的value格式，当前使用的是
          [经度，维度，名称，数据项（业务上tooltip可能需要展示多个指标，所以该数据项会塞入全部指标，以及其他为了方便渲染所需的数据）]
          其他类型value格式可参考echarts3d地图文档
        */
        let longitude = ''
        let latitude = ''
        Object.keys(seriesObj).forEach(key => {
          const {code} = this.prop.metrics.find(metItem => metItem.fieldName === key)
          if (key === '经度') {
            longitude = code ? seriesObj[key][index][code] : seriesObj[key][index]
          } else if (key === '纬度') {
            latitude = code ? seriesObj[key][index][code] : seriesObj[key][index]
          } else {
            obj[key] = code ? seriesObj[key][index][code] : seriesObj[key][index]
          }
          obj.name = item
        })
        return {
          label: {
            show: true,
            align: 'center',
            verticalAlign: 'bottom',
            distance: -105,
            position: 'bottom',
            formatter: (params) => {
              // 格式化label，根据业务具体参考echarts富文本标签文档
              const data = params?.value[params?.value?.length - 1] || {}
              let dis = ''
              const dataLen = data?.name?.length || 0
              for (let i = 0; i < Math.floor(dataLen / 2); i++) {
                dis += '　'
              }
              return `${dis}{area|}\n{text|${data.name}} `
            },
            rich: { // 富文本配置项, 根据ui设计展示label，具体参考echarts富文本标签文档
              area: {
                width: 60,
                height: 45,
                backgroundColor: {
                  image: companyIcon
                }
              },
              text: {
                color: '#ffffff',
                fontSize: 13,
                align: 'center',
                verticalAlign: 'bottom',
                width: '120%',
                height: 21,
                padding: [0, 0, 2, 0],
                backgroundColor: {
                  image: areaBgIcon
                }
              }
            }
          },
          emphasis: { // 鼠标hoverlabel时的格式化label，参考echarts文档emphasis配置项
            disabled: false,
            label: {
              show: true,
              align: 'center',
              verticalAlign: 'bottom',
              distance: -105,
              position: 'bottom',
              formatter: (params) => {
                const data = params?.value[params?.value?.length - 1] || {}
                let dis = ''
                const dataLen = data?.name?.length || 0
                for (let i = 0; i < Math.floor(dataLen / 2); i++) {
                  dis += '　'
                }
                return `${dis}{area|}\n{text|${data.name}} `
              },
              rich: {
                area: {
                  width: 60,
                  height: 45,
                  backgroundColor: {
                    image: companyIcon,
                  },
                },
                text: {
                  color: "#ffffff",
                  fontSize: 13,
                  align: "center",
                  verticalAlign: "top",
                  width: "120%",
                  height: 21,
                  padding: [0, 0, 2, 0],
                  backgroundColor: {
                    image: areaBgIcon,
                  },
                },
              },
            },
          },
          name: item,
          value: [
            `${longitude}`,
            `${latitude}`,
            item,
            obj,
          ]
        }
      })
      // 地图配置项，参考echarts 3D地图
      const option = {
        title: {
          text: "地图",
          textStyle: {
            fontWeight: "bold",
            fontSize: 13,
            color: "#000000",
            fontStyle: "normal",
          },
          show: false,
          left: "8px",
          top: "8px",
        },
        tooltip: {
          show: true,
          backgroundColor: 'none',
          borderColor: 'none',
          borderWidth: 0,
          padding: 0,
          formatter: (params) => {
            // 格式化鼠标hover时的tooltip, 根据业务需要和ui设计展示指标内容
            const data = params.value[params.value.length - 1] || {}
            let domStr = ''
            Object.keys(data).forEach(item => {
              if (item !== 'name') {
                const unit = this.getUnit(item)
                domStr += `<div style="font-size: 12px;line-height:16px;margin-top:5px;display:flex;">
                          <span style="flex: 4;">${item}: </span>
                          <span style="flex: 6;color: #3FEBFF;">${data[item]} ${unit}</span>
                        </div>`
              }
            })
            return `<div style="background: #002b5c80;border: 1px solid #46A5E2;padding: 12px;color: #ffffff;min-width:200px;">
                      <div style="font-size: 14px;line-height:20px;">${data.name}</div>
                      ${domStr}
                    </div>`
          }
        },
        geo3D: { // geo3D配置项，3D地图的主要配置项，主要处理3d地图本身的渲染，参考echarts geo3D配置
          map: "china",
          roam: true,
          type: "geo3D",
          instancing: true,
          boxHeight: 20,
          regionHeight: 3.6,
          silent: true,
          itemStyle: {
            opacity: 1,
            borderWidth: 0.8,
            borderColor: "#52F1F5",
            emphasis: {
              disabled: true,
            },
          },
          label: {
            show: false,
          },
          emphasis: {
            disabled: true,
            label: {
              show: false,
            }
          },
          shading: "realistic",
          realisticMaterial: {
            textureTiling: 1,
            textureOffset: 0,
            detailTexture: mapBg,
            roughness: 0,
            metalness: 0,
            roughnessAdjust: 0,
          },
          postEffect: {
            enable: false,
          },
          viewControl: {
            autoRotate: true,
            autoRotateDirection: "cw",
            autoRotateSpeed: 100,
            beta: -90,
            minBeta: -90,
            maxBeta: 10,
            alpha: 65,
            distance: 100,
            center: [0, -15, 0],
          },
          light: {
            main: {
              color: "#52F1F5",
              intensity: 7,
              shadowQuality: "midum",
              shadow: false,
              alpha: 173,
              beta: 190,
            },
            ambient: {
              color: "#ffffff",
              intensity: 0.2,
            },
          },
        },
        series: [ // 根据指标数据，在地图上标点展示，参考geo3D的series配置
          {
            type: "scatter3D",
            coordinateSystem: "geo3D",
            geo3DIndex: 0,
            symbolSize: 85,
            symbol: "none",
            itemStyle: {
              borderWidth: 0.5,
              borderColor: "#fff",
            },
            label: {
              show: true,
              position: [0, 0],
              distance: 0,
              opacity: 1,
            },
            data: renderData,
          },
        ],
      };
      // 矿山演示使用的写死代码配置项
      if (showDefaultCompany) {
        option.series = [
          {
            name: 'bar3D',
            type: "bar3D",
            coordinateSystem: 'geo3D',
            barSize: 1.5, //柱子粗细
            shading: 'realistic',
            opacity: 1,
            bevelSize: 0.5,
            label: {
              show: true,
              formatter(params) {
                return `{${params.value[params.value.length - 1]}|${params.data.name}}`
              },
              rich: {
                white: {
                  color: '#ffffff',
                  fontSize: 18,
                },
                red: {
                  color: '#ff3333',
                  fontSize: 18,
                },
                blue: {
                  color: '#ff99ff',
                  fontSize: 18,
                },
                yellow: {
                  color: '#ccff00',
                  fontSize: 18,
                },
                green: {
                  color: '#00ff00',
                  fontSize: 18,
                }
              },
            },
            data: [
              {
                name: '中材矿山（集团）',
                value: [118.91229, 32.02801, 0, 'white']
              },
              {
                name: '南京公司 年产量：4167.42',
                value: [118.91229, 32.02801, 4167.42, 'red']
              },
              {
                name: '天津公司	年产量：5840.28',
                value: [117.18556, 39.12553, 5840.28, 'blue']
              },
              {
                name: '西安公司	年产量：3958.64',
                value: [108.98059, 34.37619, 3958.64, 'yellow']
              },
              {
                name: '兖州公司	年产量：4434.82',
                value: [116.83503, 35.56658, 4434.82, 'green']
              },
            ]
          }
        ]
      }
      return option
    },
    // 生成双碳地图配置项，相关配置项注释，参考generateNormalOptionData的注释，大部分是重复的
    async generateIndividualOptionData() {
      const {
        categories = [],
        series = []
      } = this.getDimentionOption()
      let seriesObj = {}
      series.forEach(item => {
        seriesObj[item.name] = item.data
      })
      const renderData = categories.map((item, index) => {
        let obj = {}
        let longitude = AREA_LIST.find(area => area.name === item)?.cp[0] || ''
        let latitude = AREA_LIST.find(area => area.name === item)?.cp[1] || ''
        Object.keys(seriesObj).forEach(key => {
          const {code} = this.prop.metrics.find(metItem => metItem.fieldName === key)
          const {code: NumberCode} = this.prop.metrics.find(metItem => metItem.fieldName === '工厂数量')
          if (key === '经度') {
            if (longitude === '') {
              longitude = (code ? seriesObj[key][index][code] : seriesObj[key][index]) / (NumberCode ? seriesObj['工厂数量'][index][NumberCode] : seriesObj['工厂数量'][index])
            }
          } else if (key === '维度') {
            if (latitude === '') {
              latitude = (code ? seriesObj[key][index][code] : seriesObj[key][index]) / (NumberCode ? seriesObj['工厂数量'][index][NumberCode] : seriesObj['工厂数量'][index])
            }
          } else {
            obj[key] = code ? seriesObj[key][index][code] : seriesObj[key][index]
          }
          obj.district = item
        })
        return {
          label: {
            show: true,
            align: 'center',
            verticalAlign: 'bottom',
            distance: -65,
            formatter: (params) => {
              const data = params.value[params.value.length - 1] || {}
              if (!AREA_NAME_LIST.includes(data.district)) {
                return '　　　　　　'
              } else {
                let dis = ''
                for (let i = 0; i < Math.floor(data.district.length / 2); i++) {
                  dis += '　'
                }
                return `${dis}{area|}\n{text|${data.district}} `
              }
            },
            rich: {
              area: {
                width: 60,
                height: 45,
                backgroundColor: {
                  image: companyIcon
                }
              },
              text: {
                color: '#ffffff',
                fontSize: 13,
                align: 'center',
                verticalAlign: 'bottom',
                width: '120%',
                height: 21,
                padding: [0, 0, 2, 0],
                backgroundColor: {
                  image: areaBgIcon
                }
              }
            }
          },
          emphasis: {
            disabled: false,
            label: {
              show: true,
              align: 'center',
              verticalAlign: 'bottom',
              distance: -65,
              formatter: (params) => {
                const data = params.value[params.value.length - 1] || {}
                if (!AREA_NAME_LIST.includes(data.district)) {
                  return ' '
                } else {
                  let dis = ''
                  for (let i = 0; i < Math.floor(data.district.length / 2); i++) {
                    dis += '　'
                  }
                  return `${dis}{area|}\n{text|${data.district}} `
                }
              },
              rich: {
                area: {
                  width: 60,
                  height: 45,
                  backgroundColor: {
                    image: companyIcon,
                  },
                },
                text: {
                  color: "#ffffff",
                  fontSize: 13,
                  align: "center",
                  verticalAlign: "top",
                  width: "120%",
                  height: 21,
                  padding: [0, 0, 2, 0],
                  backgroundColor: {
                    image: areaBgIcon,
                  },
                },
              },
            },
          },
          name: item,
          value: [
            `${longitude}`,
            `${latitude}`,
            item,
            obj,
          ]
        }
      })
      if (!this.mapDataJson) {
        await this.getMapData()
      }
      // 双碳特殊的地图数据处理
      const newFeature = []
      const jsonData = JSON.parse(this.mapDataJson)
      // 按区域层级处理地图数据结构，双碳业务
      Object.keys(AREA_CODE_MAP).forEach((distKey, distIndex) => {
        const distPro = []
        AREA_CODE_MAP[distKey].forEach(pro => {
          jsonData.features.forEach(fea => {
            if (pro === ('156' + fea.properties.adcode)) {
              distPro.push(fea)
            }
          })
        })
        // 区域数据项结构，此结构基本固定，参考地图数据的geoJson， 双碳业务
        const disProObj = {
          geometry: {
            coordinates: AREA_JSON_MAP[distKey].features[0].geometry.coordinates,
            type: AREA_JSON_MAP[distKey].features[0].geometry.type
          },
          properties: {
            acroutes: [100000],
            adcode: distKey.replace('156', '') * 1,
            level: 'province',
            name: AREA_NAME_MAP[distKey],
            cp: AREA_CP_MAP[distKey],
            center: AREA_CP_MAP[distKey],
            centroid: AREA_CP_MAP[distKey],
            parent: {
              adcode: 100000
            },
            childrenNum: distPro.length,
            childrennum: distPro.length,
            subFeatureIndex: distIndex + 1,
            subfeatureindex: distIndex + 1
          },
          type: 'Feature'
        }
        newFeature.push(disProObj)
      })
      // 处理海南数据
      const haiNanFeature = jsonData.features.find(feat => feat.properties.name === '海南省')
      haiNanFeature.geometry = HAI_NAN_JSON.geometry
      // 根据过滤条件的区域，过滤出需要渲染的地图数据，双碳业务
      if (this.filterDistrict) {
        const value = this.filterDistrict
        const areaCode = AREA_CODE_NAME_MAP[value]
        this.curAreaData = AREA_LIST.find(item => item.code === areaCode)
        renderData.push({
          name: this.curAreaData.name, value: [...this.curAreaData.cp, this.curAreaData.name, {
            district: this.curAreaData.name
          }]
        })
        const list = AREA_CODE_MAP[areaCode]
        const countryCode = areaCode.substring(0, 3)
        jsonData.features = jsonData.features.filter(item => {
          return list.includes(countryCode + item.properties.adcode)
        })
      } else {
        // 全国地图数据
        jsonData.features = [...newFeature, ...jsonData.features.filter(feat => !PROVINCE_LIST.includes(feat.properties.name) && feat.properties.name && feat.properties.name !== '海南省'), haiNanFeature]
      }
      const optionData = this.deepClone(jsonData);
      window.echarts.registerMap("china", optionData);
      const curAreaData = this.curAreaData
      const option = {
        title: {
          text: "集团驾驶舱地图",
          textStyle: {
            fontWeight: "bold",
            fontSize: 13,
            color: "#000000",
            fontStyle: "normal",
          },
          show: false,
          left: "8px",
          top: "8px",
        },
        tooltip: {
          show: true,
          backgroundColor: 'none',
          borderColor: 'none',
          borderWidth: 0,
          padding: 0,
          formatter: function (params) {
            const data = params.value[params.value.length - 1] || {}
            let domStr = ''
            Object.keys(data).forEach(item => {
              if (item !== 'company' && item !== 'district') {
                domStr += `<div style="font-size: 8px;line-height:16px;margin-top:5px;display:flex;">
                          <span style="flex: 4;">${item}: </span>
                          <span style="flex: 6;color: #3FEBFF;">${(data[item] * 1 || 0).toFixed(item === '工厂数量' ? 0 : 2)}${fieldsUnitMap[item] || ''}</span>
                        </div>`
              }
            })
            return `<div style="background: #002b5c80;border: 1px solid #46A5E2;padding: 12px;color: #ffffff;min-width:200px;">
                      <div style="font-size: 13px;line-height:20px;">${data.company || data.district}</div>
                      ${domStr}
                    </div>`
          }
        },
        geo3D: {
          map: "china",
          roam: true,
          type: "geo3D",
          instancing: true,
          boxHeight: 20,
          regionHeight: 3.6,
          silent: true,
          itemStyle: {
            opacity: 1,
            borderWidth: 0.8,
            borderColor: "#52F1F5",
            emphasis: {
              disabled: true,
            },
          },
          label: {
            show: false,
          },
          emphasis: {
            disabled: true,
            label: {
              show: false,
            }
          },
          shading: "realistic",
          realisticMaterial: {
            textureTiling: 1,
            textureOffset: 0,
            detailTexture: mapBg,
            roughness: 0,
            metalness: 0,
            roughnessAdjust: 0,
          },
          postEffect: {
            enable: false,
          },
          viewControl: {
            autoRotate: true,
            autoRotateDirection: "cw",
            autoRotateSpeed: 100,
            beta: -90,
            minBeta: -90,
            maxBeta: 10,
            alpha: 65,
            distance: 100,
            center: [0, -15, 0],
          },
          light: {
            main: {
              color: "#52F1F5",
              intensity: 7,
              shadowQuality: "midum",
              shadow: false,
              alpha: 173,
              beta: 190,
            },
            ambient: {
              color: "#ffffff",
              intensity: 0.2,
            },
          },
        },
        series: [
          {
            name: "工厂数量",
            type: "map3D",
            geoIndex: 0,
            data: renderData,
            itemStyle: {
              normal: {},
            },
            coordinateSystem: "geo3D",
            shading: "lambert",
            opacity: 1,
          },
          {
            type: "scatter3D",
            coordinateSystem: "geo3D",
            geo3DIndex: 0,
            symbolSize: 100,
            symbol: "none",
            itemStyle: {
              borderWidth: 0.5,
              borderColor: "#fff",
            },
            label: {
              show: !!curAreaData, // 根据是区域还是全国判断是否展示label，双碳业务
              position: [20, 20],
              distance: -55,
              opacity: 1,
              formatter(params) {
                // 渲染区域和渲染公司的label展示要不一样，双碳业务
                const data = params.value[params.value.length - 1] || {}
                if (curAreaData && data.district === curAreaData.name) {
                  let dis = ''
                  for (let i = 0; i < Math.floor(data.district.length / 2); i++) {
                    dis += '　'
                  }
                  return `${dis}{area|}\n{text|${data.district}}`
                } else {
                  return `{factory|}`
                }
              },
              rich: {
                factory: {
                  width: 40,
                  height: 30,
                  backgroundColor: {
                    image: factoryIcon,
                  },
                },
                area: {
                  width: 40,
                  height: 30,
                  backgroundColor: {
                    image: companyIcon,
                  },
                },
                text: {
                  color: "#ffffff",
                  fontSize: 9,
                  align: "center",
                  verticalAlign: "top",
                  width: "120%",
                  height: 14,
                  padding: [0, 5, 2, 5],
                  backgroundColor: {
                    image: areaBgIcon,
                  },
                },
              },
            },
            emphasis: {
              disabled: false,
              label: {
                show: !!curAreaData, // 根据是区域还是全国判断是否展示label的放大，双碳业务
                formatter(params) {
                  const data = params.value[params.value.length - 1] || {}
                  if (curAreaData && data.district === curAreaData.name) {
                    return `{area|}\n{text|${data.district}}`
                  } else {
                    return `{factory|}`
                  }
                },
                rich: {
                  factory: {
                    width: 50,
                    height: 40,
                    backgroundColor: {
                      image: factoryIcon,
                    },
                  },
                  area: {
                    width: 50,
                    height: 40,
                    backgroundColor: {
                      image: companyIcon,
                    },
                  },
                  text: {
                    color: "#ffffff",
                    fontSize: 9,
                    align: "center",
                    verticalAlign: "top",
                    width: "120%",
                    height: 14,
                    padding: [0, 5, 2, 5],
                    backgroundColor: {
                      image: areaBgIcon,
                    },
                  },
                },
              },
            },
            // 区域和全国的数据展示不同，双碳业务
            data: !curAreaData ? renderData : renderData.map(item => ({
              name: (item.value[item.value.length - 1] || {}).district,
              value: item.value
            })),
          },
        ],
      };
      // 如果是区域地图，需要有公司到公司之间的飞线动效，双碳业务
      if (this.curAreaData) {
        const lineData = this.initFactoryData(renderData)
        option.series.push(lineData)
        option.geo3D.viewControl.distance = this.curAreaData?.name ? AREA_DISTANCE_MAP[this.curAreaData?.name] : 100
        option.geo3D.regionHeight = this.curAreaData?.name ? (AREA_DISTANCE_MAP[this.curAreaData?.name] / 100) * 3.6 : 3.6
      }
      return option
    }
  },
};
</script>
